export const getRelativeTimeUntil = (locale: string, date: Date) => {
  const targetDate = new Date(date);
  const diffInMs = targetDate.getTime() - Date.now();

  if (diffInMs < 0) {
    return '';
  }

  const rtf = new Intl.RelativeTimeFormat(locale, {
    numeric: 'auto',
    style: 'long',
    localeMatcher: 'best fit',
  });

  const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
  const diffInHours = Math.floor(diffInMinutes / 60);
  const diffInDays = Math.floor(diffInHours / 24);

  if (diffInDays >= 1) {
    return rtf.format(diffInDays, 'day');
  } else if (diffInHours >= 1) {
    return rtf.format(diffInHours, 'hour');
  } else {
    return rtf.format(diffInMinutes, 'minute');
  }
};
